;(function () {
  'use strict'

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const SELECTOR_SLIDER$1 = '.sym-slides-general'
  const SELECTOR_SLIDER$2 = '.home-slides'
  const SELECTOR_SLIDER$3 = '.slider-full__slider'
  const SELECTOR_SLIDER$4 = '.slider-quad__slider'
  const SELECTOR_SLIDER$5 = '.slider-single__slider'
  const SELECTOR_SLIDER$6 = '.accommodation__slider'
  const SELECTOR_SLIDER$7 = '.specials-block__slider'

  const DATA_SELECTOR$1 = 'data-tb-prev'
  const DATA_SELECTOR$2 = 'data-tb-next'

  /**
   * ------------------------------------------------------------------------
   * Functions - Public
   * ------------------------------------------------------------------------
   */

  const slickGeneral = () => {
    $(SELECTOR_SLIDER$1).slick({
      infinite: false,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
    })
  }

  const slickHome = () => {
    let SLIDER = document.querySelector(SELECTOR_SLIDER$2)

    if (SLIDER !== null) {
      let ARROW_PREV =
        SLIDER.hasAttribute(DATA_SELECTOR$1) !== null
          ? SLIDER.dataset.tbPrev
          : ''
      let ARROW_NEXT =
        SLIDER.hasAttribute(DATA_SELECTOR$2) !== null
          ? SLIDER.dataset.tbNext
          : ''

      $(SELECTOR_SLIDER$2).slick({
        accessibility: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              arrows: false,
            },
          },
        ],
      })
    }
  }

  const slickFullPage = () => {
    let SLIDER = document.querySelectorAll(SELECTOR_SLIDER$3)

    SLIDER.forEach((slider) => {
      let ARROW_NEXT = slider.hasAttribute(DATA_SELECTOR$2)
        ? slider.dataset.tbNext
        : ''

      $(slider).slick({
        adaptiveWidth: true,
        centerMode: true,
        centerPadding: '180px',
        slidesToShow: 1,
        nextArrow: ARROW_NEXT,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              adaptiveWidth: false,
              adaptiveHeight: false,
              arrows: false,
              dots: true,
              centerMode: false,
              centerPadding: '0px',
            },
          },
        ],
      })
    })
  }

  const slickQuad = () => {
    let SLIDER = document.querySelector(SELECTOR_SLIDER$4)

    if (SLIDER !== null) {
      let ARROW_PREV = SLIDER.hasAttribute(DATA_SELECTOR$1)
        ? SLIDER.dataset.tbPrev
        : ''
      let ARROW_NEXT = SLIDER.hasAttribute(DATA_SELECTOR$2)
        ? SLIDER.dataset.tbNext
        : ''

      $(SELECTOR_SLIDER$4).slick({
        fade: true,
        cssEase: 'linear',
        arrows: true,
        dots: true,
        speed: 800,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              arrows: false,
            },
          },
        ],
      })
    }
  }

  const slickSingle = () => {
    let SLIDER = document.querySelector(SELECTOR_SLIDER$5)

    if (SLIDER !== null) {
      let ARROW_PREV = SLIDER.hasAttribute(DATA_SELECTOR$1)
        ? SLIDER.dataset.tbPrev
        : ''
      let ARROW_NEXT = SLIDER.hasAttribute(DATA_SELECTOR$2)
        ? SLIDER.dataset.tbNext
        : ''

      $(SELECTOR_SLIDER$5).slick({
        fade: true,
        cssEase: 'linear',
        arrows: true,
        dots: true,
        speed: 800,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              arrows: false,
            },
          },
        ],
      })
    }
  }

  const slickAccommodation = () => {
    let SLIDER = document.querySelectorAll(SELECTOR_SLIDER$6)

    SLIDER.forEach((slider) => {
      let ARROW_PREV = slider.hasAttribute(DATA_SELECTOR$1)
        ? slider.dataset.tbPrev
        : ''
      let ARROW_NEXT = slider.hasAttribute(DATA_SELECTOR$2)
        ? slider.dataset.tbNext
        : ''

      $(slider).slick({
        fade: true,
        cssEase: 'linear',
        arrows: true,
        dots: false,
        speed: 800,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              arrows: false,
            },
          },
        ],
      })
    })
  }

  const slickSpecials = () => {
    let SLIDER = document.querySelectorAll(SELECTOR_SLIDER$7);

    SLIDER.forEach(slider => {
      let ARROW_PREV = slider.dataset.tbPrev || '';
      let ARROW_NEXT = slider.dataset.tbNext || '';

      $(slider).slick({
        speed: 800,
        infinite: true,
        prevArrow: ARROW_PREV,
        nextArrow: ARROW_NEXT,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 768,
            settings: "unslick"
          },
        ],
      })
    })
  };

  /**
   * ------------------------------------------------------------------------
   * DOM Content Loaded is ready available
   * @param {*} callback
   * ------------------------------------------------------------------------
   */
  const onDOMLoaded = (callback) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(callback, 1)
      })
    } else {
      document.addEventListener('DOMContentLoaded', callback)
    }
  }

  onDOMLoaded(
    slickGeneral(),
    slickHome(),
    slickFullPage(),
    slickQuad(),
    slickSingle(),
    slickAccommodation(),
    slickSpecials()
  )
})()
